if (!window.__osDecor) { window.__osDecor = true;
/* Decor BeadPops : mega-menu, onglets, menu mobile.
   EXTRAIT de marques/beadpops/pages/accueil-elvis-v2/page.js par liquid-builder/lib/extrait-decor.mjs.
   Ce decor sert sur TOUTES les pages : il ne peut plus vivre dans le script d'une page.
   Ne pas editer a la main. */

/* ==========================================================================
   6. LE MENU DÉROULANT DES MODÈLES
   Il s'ouvre au survol comme au clavier. Le survol seul enfermerait les
   personnes qui naviguent au clavier ou au lecteur d'écran ; le clic seul
   ferait rater le geste à la souris. On garde les deux, avec un délai à la
   fermeture pour que la diagonale vers le panneau ne le referme pas.
   ========================================================================== */
(function menuModeles(){
  var bouton  = document.querySelector('[data-declencheur]');
  var panneau = document.querySelector('[data-panneau]');
  var entete  = document.querySelector('.entete');
  if (!bouton || !panneau || !entete) { return; }

  var grand = window.matchMedia('(min-width: 901px)');
  var minuteur = null;
  var epingle = false;

  function ouvre(){
    clearTimeout(minuteur);
    if (!grand.matches) { return; }
    panneau.hidden = false;
    // Un reflow avant de poser l'attribut, sinon le navigateur applique
    // l'état d'arrivée du même coup et la transition ne joue pas.
    void panneau.offsetWidth;
    panneau.setAttribute('data-ouvert', '');
    bouton.setAttribute('aria-expanded', 'true');
  }

  function ferme(){
    clearTimeout(minuteur);
    epingle = false;
    panneau.removeAttribute('data-ouvert');
    bouton.setAttribute('aria-expanded', 'false');
    minuteur = setTimeout(function(){ panneau.hidden = true; }, 200);
  }

  function fermeTard(){ clearTimeout(minuteur); minuteur = setTimeout(ferme, 160); }

  // ⛔ LE SURVOL ET LE CLIC SE NEUTRALISAIENT. Le survol ouvrait le panneau, puis le
  // clic voyait « deja ouvert » et le refermait : a la souris on ouvrait en arrivant
  // sur le bouton, et on refermait en cliquant dessus. Le menu paraissait mort alors
  // que ses dix liens etaient la. Defaut vecu en production jusqu'au 2026-09-12.
  //
  // Le geste attendu d'un megamenu au survol : le survol previsualise, le clic EPINGLE
  // (le panneau reste quand la souris s'en va), un second clic ferme.
  bouton.addEventListener('click', function(){
    if (epingle) { epingle = false; ferme(); return; }
    epingle = true; ouvre();
  });
  bouton.addEventListener('mouseenter', ouvre);
  bouton.addEventListener('mouseleave', function(){ if (!epingle) { fermeTard(); } });
  panneau.addEventListener('mouseenter', function(){ clearTimeout(minuteur); });
  panneau.addEventListener('mouseleave', function(){ if (!epingle) { fermeTard(); } });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && bouton.getAttribute('aria-expanded') === 'true') {
      ferme(); bouton.focus();
    }
  });
  document.addEventListener('click', function(e){
    if (!entete.contains(e.target)) { ferme(); }
  });
  panneau.addEventListener('click', function(e){ if (e.target.closest('a')) { ferme(); } });

  // 2026-10-11, passe UX : le panneau est rendu APRES la barre dans le DOM. Au clavier,
  // Entree ouvrait le menu, puis Tab sautait a « Recharges de perles » : les deux entrees
  // du panneau n'etaient atteintes qu'apres le panier, panneau ouvert ou non (mesure).
  // Tab depuis « Modeles » ouvert entre donc dans le panneau ; Tab apres sa derniere
  // entree ressort sur le lien suivant de la barre et referme ; Maj+Tab sur la premiere
  // revient a « Modeles ». On ne deplace pas le balisage : la home en porte une copie.
  function liensPanneau(){ return panneau.querySelectorAll('a[href]'); }
  // Maj+Tab depuis « Modeles » ouvert laissait le panneau epingle par-dessus la page.
  bouton.addEventListener('blur', function(e){
    if (e.relatedTarget && !panneau.contains(e.relatedTarget)) { ferme(); }
  });
  bouton.addEventListener('keydown', function(e){
    if (e.key !== 'Tab' || e.shiftKey || bouton.getAttribute('aria-expanded') !== 'true') { return; }
    var l = liensPanneau();
    if (l.length) { e.preventDefault(); l[0].focus(); }
  });
  panneau.addEventListener('keydown', function(e){
    if (e.key !== 'Tab') { return; }
    var l = liensPanneau();
    if (!l.length) { return; }
    if (e.shiftKey && document.activeElement === l[0]) { e.preventDefault(); bouton.focus(); return; }
    if (!e.shiftKey && document.activeElement === l[l.length - 1]) {
      e.preventDefault();
      var barre = [].slice.call(entete.querySelectorAll('.nav > a, .nav > button, [data-panier]'));
      var suivant = barre[barre.indexOf(bouton) + 1];
      ferme();
      if (suivant) { suivant.focus(); }
    }
  });

})();

/* ==========================================================================
   7. LES ONGLETS UNIVERS / NIVEAU
   Le même mécanisme sert au déroulant de bureau et au menu mobile : une
   rangée de boutons, autant de vues, une seule visible.
   ========================================================================== */
(function onglets(){
  [['.panneau-rail button', '.panneau-vue,.panneau-sous-titre'],
   ['[data-mm-onglets] button', '.mm-vue,.mm-sous-titre']].forEach(function(paire){
    var boutons = document.querySelectorAll(paire[0]);
    var vues    = document.querySelectorAll(paire[1]);
    if (!boutons.length) { return; }
    boutons.forEach(function(o){
      o.addEventListener('click', function(){
        boutons.forEach(function(x){ x.classList.toggle('est-actif', x === o); });
        vues.forEach(function(v){ v.hidden = v.dataset.vue !== o.dataset.vue; });
      });
    });
  });
})();

/* ==========================================================================
   9. LE MENU MOBILE
   ========================================================================== */
/* 2026-10-11, passe UX. Mesure avant : menu ouvert, la page defilait dessous (on la
   voyait sous les cartes), Tab sortait du menu vers la page, Echap fermait sans rendre
   le focus au bouton, le bouton disait toujours « Ouvrir le menu », et un tap sur
   l'image ou le texte d'une carte (pas sur le <a> lui-meme) ne refermait rien.
   Maintenant : le menu couvre l'ecran sous la barre (CSS, fin de _decor.css), la page
   est bloquee, le focus tourne dans l'en-tete, Echap rend le focus, le libelle suit
   l'etat, et le menu se ferme si l'ecran repasse en grand ou si l'on ouvre le panier. */
(function menuMobile(){
  var bouton = document.querySelector('[data-burger]');
  var menu   = document.querySelector('[data-menu]');
  var entete = document.querySelector('.entete');
  if (!bouton || !menu) { return; }

  function estOuvert(){ return bouton.getAttribute('aria-expanded') === 'true'; }
  function ferme(rendFocus){
    if (!estOuvert()) { return; }
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-label', 'Ouvrir le menu');
    menu.removeAttribute('data-ouvert');
    menu.hidden = true;
    document.documentElement.style.overflow = '';
    if (rendFocus) { bouton.focus(); }
  }
  function ouvre(){
    bouton.setAttribute('aria-expanded', 'true');
    bouton.setAttribute('aria-label', 'Fermer le menu');
    menu.hidden = false;
    menu.setAttribute('data-ouvert', '');
    menu.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';
  }
  bouton.addEventListener('click', function(){ if (estOuvert()) { ferme(false); } else { ouvre(); } });
  menu.addEventListener('click', function(e){ if (e.target.closest('a')) { ferme(false); } });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && estOuvert()) { ferme(true); }
  });
  // le focus reste dans l'en-tete (bouton, logo, panier, menu) tant que le menu couvre l'ecran
  if (entete) {
    entete.addEventListener('keydown', function(e){
      if (e.key !== 'Tab' || !estOuvert()) { return; }
      var f = [].slice.call(entete.querySelectorAll('a[href], button:not([disabled])'))
        .filter(function(el){ return el.getClientRects().length > 0; });
      if (!f.length) { return; }
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    });
  }
  // ouvrir le panier depuis le menu : on ferme d'abord, le tiroir pose son propre blocage
  var panier = document.querySelector('[data-panier]');
  if (panier) { panier.addEventListener('click', function(){ ferme(false); }); }
  var petit = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  function surChangement(){ if (petit && !petit.matches) { ferme(false); } }
  if (petit && petit.addEventListener) { petit.addEventListener('change', surChangement); }
  else if (petit && petit.addListener) { petit.addListener(surChangement); }
})();

/* 2026-10-11, passe UX : LE COMPTEUR DU PANIER. Constate en ligne le 2026-10-11 : un
   article au panier, la pastille de l'en-tete restait cachee a « 0 » sur toutes les
   pages. Personne ne la remplissait : le tiroir du theme ecrit dans [data-bp-cart-count],
   la pastille n'ecoutait que [data-pn-compte] (le tiroir de la maquette).
   La pastille porte maintenant les deux attributs ; on lit le panier au chargement
   (Shopify seulement), on suit ce que le tiroir y ecrit, et l'evenement
   « beadpops:cart-updated ». Le nombre passe aussi dans le nom du bouton. */
(function compteurPanier(){
  var bouton = document.querySelector('[data-panier]');
  var pastille = bouton && bouton.querySelector('[data-pn-compte], [data-bp-cart-count]');
  if (!bouton || !pastille) { return; }

  function pose(valeur){
    var n = parseInt(valeur, 10) || 0;
    if (pastille.textContent !== String(n)) { pastille.textContent = String(n); }
    pastille.hidden = n < 1;
    bouton.setAttribute('aria-label', n < 1 ? 'Ouvrir le panier'
      : 'Ouvrir le panier, ' + n + (n > 1 ? ' articles' : ' article'));
  }
  function lit(){
    if (!window.Shopify || !window.fetch) { return; }
    var racine = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(racine + 'cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      /* 2026-10-11 : meme compte que le tiroir (snippets/bp-cart-drawer.liquid, nbArticles) : les lignes « Modele du kit » (handle modele-du-kit) voyagent avec le kit et ne comptent pas. Avec item_count, un kit a 8 modeles affichait 9. */
      .then(function(c){ pose((c.items || []).reduce(function(n, l){ return n + (l.handle === 'modele-du-kit' ? 0 : l.quantity); }, 0)); })
      .catch(function(){});
  }
  if (window.MutationObserver) {
    new MutationObserver(function(){ pose(pastille.textContent); })
      .observe(pastille, { childList: true, characterData: true, subtree: true });
  }
  window.addEventListener('beadpops:cart-updated', function(e){
    if (e.detail && e.detail.count != null) { pose(e.detail.count); } else { lit(); }
  });
  // retour arriere depuis la caisse : la page sort du cache, le panier a pu changer
  window.addEventListener('pageshow', function(e){ if (e.persisted) { lit(); } });
  lit();
})();

/* Pied : sur telephone les trois colonnes (<details>) se replient, sur ordinateur elles
   restent ouvertes et leur titre ne replie rien. Sans JS, tout reste ouvert. */
(function piedPlis(){
  var cols = [].slice.call(document.querySelectorAll('.pied-col'));
  if (!cols.length || !window.matchMedia) { return; }
  var mq = window.matchMedia('(max-width:560px)');
  // 2026-10-11, passe UX : sur ordinateur le titre ne replie rien, mais il restait un arret
  // de tabulation (trois Tab pour rien entre l'inscription et les liens). Retire de
  // l'ordre de tabulation sur grand ecran, rendu sur telephone ou il sert.
  function regle(){ cols.forEach(function(d){
    var s = d.querySelector('summary');
    if (mq.matches) { d.removeAttribute('open'); if (s) { s.removeAttribute('tabindex'); } }
    else { d.setAttribute('open', ''); if (s) { s.setAttribute('tabindex', '-1'); } }
  }); }
  cols.forEach(function(d){
    var s = d.querySelector('summary');
    if (s) { s.addEventListener('click', function(e){ if (!mq.matches) { e.preventDefault(); } }); }
  });
  regle();
  if (mq.addEventListener) { mq.addEventListener('change', regle); } else if (mq.addListener) { mq.addListener(regle); }
})();

/* L icone panier de l en-tete ouvre le tiroir fonctionnel du theme, pas celui de la
   maquette. Repli sur /cart si le tiroir du theme n est pas charge : mieux vaut la
   page panier que rien du tout. */
(function panier(){
  var bouton = document.querySelector('[data-panier]');
  if (!bouton) { return; }
  bouton.addEventListener('click', function(){
    if (window.BPCart && typeof window.BPCart.open === 'function') { window.BPCart.open(); return; }
    window.location.href = '/cart';
  });
})();

}
